<template>
  <div class="createOrEditRoot">
    <div class="resourceFormPage divContainer configModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else class="resourceFormPage__layout">
        <el-form
          ref="ruleForm"
          label-position="top"
          size="small"
          class="resourceFormPage__form"
          :model="ruleForm"
          :rules="rules"
          hide-required-asterisk
          @submit.native.prevent
        >
          <div class="resourceFormPage__headerDock">
            <header class="resourceFormPage__actionBar">
              <div class="resourceFormPage__lead">
                <h1 class="resourceFormPage__pageTitle">
                  {{ isCreate ? '新建 Auto Layout' : '编辑 Auto Layout' }}
                </h1>
              </div>
              <div class="resourceFormPage__actions">
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  @click="goBack"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--primary"
                  :disabled="uploadLoading || buttonLoading"
                  @click="submitForm"
                >
                  {{ buttonLoading ? '保存中…' : '保存' }}
                </button>
              </div>
            </header>
          </div>

          <main class="resourceFormPage__main main configFormPage__main">
            <el-card class="card linkFormSection" data-section-id="basic">
              <div slot="header" class="linkFormSection__header">
                <strong class="linkFormSection__title">基本信息</strong>
              </div>

              <div class="linkFormBasic">
                <div class="linkFormBasic__media">
                  <div class="linkFormMediaAnchor">
                    <div
                      v-if="ruleForm.configUrl"
                      class="linkFormMediaAnchor__fileTile"
                      :title="fileName || ruleForm.configUrl"
                    >
                      <i class="el-icon-document linkFormMediaAnchor__fileIcon" aria-hidden="true" />
                      <span class="linkFormMediaAnchor__fileName">
                        {{ fileName || '已上传 JSON' }}
                      </span>
                      <div class="linkFormMediaAnchor__fileActions">
                        <button
                          type="button"
                          class="linkFormMediaFileBar__btn"
                          :disabled="uploadLoading"
                          @click="triggerJsonUpload"
                        >
                          替换
                        </button>
                        <button
                          type="button"
                          class="linkFormMediaFileBar__btn linkFormMediaFileBar__btn--danger"
                          :disabled="uploadLoading"
                          @click="clearJsonUpload"
                        >
                          移除
                        </button>
                      </div>
                    </div>
                    <button
                      v-else
                      type="button"
                      class="linkFormUploadZone linkFormUploadZone--anchor"
                      :disabled="uploadLoading"
                      @click="triggerJsonUpload"
                    >
                      <i class="el-icon-upload2 linkFormUploadZone__icon" aria-hidden="true" />
                      <span>{{ uploadLoading ? '上传中…' : '上传配置文件' }}</span>
                      <span class="linkFormUploadZone__hint">仅支持 .json</span>
                    </button>
                  </div>

                  <el-upload
                    ref="jsonUpload"
                    class="configFormPage__hiddenUpload"
                    action=""
                    accept=".json,application/json"
                    :http-request="customRequest"
                    :show-file-list="false"
                  />
                  <el-form-item prop="configUrl" class="linkFormBasic__urlField">
                    <el-input v-show="false" v-model="ruleForm.configUrl" />
                  </el-form-item>
                </div>

                <div class="linkFormBasic__fields configFormPage__fields">
                  <el-form-item
                    class="configFormPage__field--wide"
                    label="配置名称"
                    prop="title"
                  >
                    <el-input
                      v-model="ruleForm.title"
                      placeholder="请输入配置名称"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item label="语言" prop="language">
                    <el-input
                      v-model="ruleForm.language"
                      placeholder="请输入语言名称"
                      clearable
                      @change.native="
                        ruleForm.language = $event.target.value.replace(/\s/g, '')
                      "
                    />
                  </el-form-item>
                  <el-form-item label="设备型号" prop="device">
                    <el-input
                      v-model="ruleForm.device"
                      placeholder="请输入设备型号"
                      clearable
                      @change.native="
                        ruleForm.device = $event.target.value.replace(/\s/g, '')
                      "
                    />
                  </el-form-item>
                </div>
              </div>
            </el-card>
          </main>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getConfigById,
  updateConfig,
  addConfig,
} from '../../../api/autoLayoutManage'
import { uploadFile } from '../../../api/comment'

export default {
  name: 'AutoLayoutCreateOrEdit',
  data() {
    return {
      isCreate: true,
      ruleForm: {
        title: '',
        language: '',
        device: '',
        configUrl: '',
      },
      loading: false,
      buttonLoading: false,
      rules: {
        title: [{ required: true, message: '配置名称不能为空', trigger: 'blur' }],
        language: [{ required: true, message: '语言不能为空', trigger: 'blur' }],
        device: [{ required: true, message: '设备型号不能为空', trigger: 'blur' }],
        configUrl: [
          {
            required: true,
            validator: this.checkFileUpload,
            trigger: ['blur', 'change'],
          },
        ],
      },
      uploadLoading: false,
      fileName: '',
    }
  },
  created() {
    this.isCreate = this.$route.path.indexOf('edit') === -1
    if (!this.isCreate) {
      this.getData()
    }
  },
  methods: {
    checkFileUpload(rule, value, callback) {
      if (!this.ruleForm.configUrl) {
        callback(new Error('请上传文件'))
      } else {
        callback()
      }
    },
    getFileName(name) {
      return name.substring(0, name.lastIndexOf('.'))
    },
    triggerJsonUpload() {
      const upload = this.$refs.jsonUpload
      if (upload && upload.$refs['upload-inner'] && upload.$refs['upload-inner'].$refs.input) {
        upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    clearJsonUpload() {
      this.fileName = ''
      this.$set(this.ruleForm, 'configUrl', '')
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.validateField('configUrl')
        }
      })
    },
    customRequest(params) {
      const str = params.file.name
      this.uploadLoading = true
      const suffix = str.substring(str.lastIndexOf('.') + 1)
      const isJson = suffix === 'json'
      if (isJson) {
        this.fileName = this.getFileName(str)
        const file = new FormData()
        file.append('file', params.file)
        uploadFile(file)
          .then((res) => {
            if (res.success) {
              this.ruleForm.configUrl = res.data
              this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                  this.$refs.ruleForm.validateField('configUrl')
                }
              })
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.uploadLoading = false
          })
      } else {
        this.$message.error('请按规定格式上传文件')
        this.uploadLoading = false
      }
      return false
    },
    getData() {
      this.loading = true
      getConfigById(this.$route.params.id)
        .then((res) => {
          if (res.success) {
            this.ruleForm = res.data
            if (res.data && res.data.configUrl) {
              const url = String(res.data.configUrl)
              const parts = url.split('/')
              this.fileName = this.getFileName(parts[parts.length - 1] || '') || '已上传 JSON'
            }
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          this.$message.error('你还有参数没有填完整')
          return false
        }
        this.buttonLoading = true
        const request = this.isCreate
          ? addConfig(this.ruleForm)
          : updateConfig(this.ruleForm)
        request
          .then((res) => {
            if (res.success) {
              this.$message.success(this.isCreate ? '新增成功!' : '编辑成功!')
              this.$router.push('/config/autoLayout/list')
            }
          })
          .catch((err) => {
            this.$message.error(err)
          })
          .finally(() => {
            this.buttonLoading = false
          })
      })
    },
    goBack() {
      this.$router.push('/config/autoLayout/list')
    },
  },
}
</script>

<style scoped>
.createOrEditRoot,
.fullContainer {
  height: 100%;
}

.resourceFormPage__form {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>

<style>
.configModule.divContainer {
  min-height: 100%;
  background: var(--link-canvas);
}

.configModule .main {
  background: transparent;
}
</style>
